import styled from "styled-components"

/** A standard HTML select */
export default styled.select`
  outline: none;
  background: ${(props) =>
    props.inline ? "rgba(128,128,128,0.2)" : "rgba(128,128,128,0.05)"};
  border-style: solid;
  border-radius: 4px;
  border-width: 1px;
  border-color: ${(props) =>
    props.active ? props.theme.colours.active : "#555"};
  color: ${(props) => props.theme.colours.text.primary};
  padding: 0.25rem;
  optgroup,
  option {
    background: #333;
    color: ${(props) => props.theme.colours.text.primary};
    padding: 0.5rem;
  }
`
